"use client";
import React, { createContext, useState, useEffect } from "react";
import { BASE_URL, UPLOAD_URL } from '../config/apiConfig';

// Create Context
export const TopSellingContext = createContext();

// Provider Component
export const TopSellingProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch top-selling products
 const fetchTopSellingProducts = () => {
  const userId = localStorage.getItem("user_id"); // get logged-in user

  // Using query param to avoid CORS issues
  const url = `${BASE_URL}/product`;

  fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === 200 && Array.isArray(data.data)) {
        const mapped = data.data.map((p) => ({
          id: p.id,
          name: p.name,
          category_id: p.category_id,
          image: `${UPLOAD_URL}/products/${p.image}`,
          stock: p.stock,
          content: p.content,
          details: p.details || [],
        }));
        setProducts(mapped);
      } else {
        setProducts([]);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching products:", err);
      setProducts([]);
      setLoading(false);
    });
};


  useEffect(() => {
    fetchTopSellingProducts();
  }, []);

  return (
    <TopSellingContext.Provider value={{ products, loading }}>
      {children}
    </TopSellingContext.Provider>
  );
};
